<template>
  <div class="main-body">
    <div class="title-bar">
      <h1>Quotes</h1>
      <div class="actions">
        <div class="primary-input" style="width: 25rem">
          <input type="search" placeholder="Search..." class="no-outline" v-model="searchText" />
          <img src="../assets/search.svg" />
        </div>
        <div class="icon-button" @click="showFilter = true">
          <img id="noHover" src="../assets/filter.svg" />
          <img id="hover" src="../assets/filter-hover.svg" />
        </div>
        <button class="add-round-btn" @click="$router.push({ name: 'quote', params: { quoteid: 'new' } })"><img src="../assets/plus-symbol.svg" />Add New</button>
      </div>
    </div>

    <div class="scrollable-div display-scrollbar">
      <table class="full-width-table quotes-table">
        <tbody>
          <tr class="table-header">
            <th>Quote #</th>
            <th>Name</th>
            <th>Job Name</th>
            <th>Date Created</th>
            <th>Valid To</th>
            <th>Salesperson</th>
            <th>Order Total</th>
            <th>Status</th>
            <th></th>
          </tr>
          <QuoteRow v-for="quote in filteredQuotes" :key="quote.QUOTEID" :quote="quote" @printQuote="printQuote" @statusUpdated="refreshQuotes" />
          <tr v-if="loadingQuotes" class="loading-row">
            <td colspan="9"><img src="../assets/spinner.svg" /></td>
          </tr>
          <tr v-if="!loadingQuotes && filteredQuotes.length === 0" class="no-results">
            <td colspan="9">No quotes found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <QuoteFilter v-if="showFilter" @closePopup="showFilter = false" />
</template>

<script>
import QuoteRow from '@/components/quotes/QuoteRow.vue';
import QuoteFilter from '@/components/quotes/QuoteFilter.vue';
import useQuotesQuery from '@/composables/useQuotesQuery';
import useUsersQuery from '@/composables/useUsersQuery';

export default {
  name: 'Quotes',
  components: {
    QuoteRow,
    QuoteFilter,
  },
  setup() {
    useQuotesQuery.useQuotesQuery();
    const { getUsers } = useUsersQuery();
    getUsers();

    return {
      quotes: useQuotesQuery.quotes,
      loadingQuotes: useQuotesQuery.loadingQuotes,
      refetchQuotes: useQuotesQuery.refetchQuotes,
      searchText: useQuotesQuery.searchText,
    };
  },
  data() {
    return {
      showFilter: false,
    };
  },
  computed: {
    filteredQuotes() {
      const search = this.searchText.trim().toLowerCase();
      if (!search) return this.quotes;

      const searchDigits = search.replace(/\D/g, '');

      return this.quotes.filter((quote) => {
        const phones = [...(quote.company?.phones || []), ...(quote.contact?.phones || [])]
          .map((phone) => phone.NUMBERDISPLAY || '')
          .filter(Boolean);

        const haystack = [
          quote.QUOTENUM ? `#${quote.QUOTENUM}` : '',
          quote.QUOTENUM?.toString() || '',
          quote.company?.NAME || '',
          `${quote.contact?.FIRSTNAME || ''} ${quote.contact?.LASTNAME || ''}`,
          quote.JOBNAME || '',
          quote.NOTES || '',
          ...phones,
        ]
          .join(' ')
          .toLowerCase();

        if (haystack.includes(search)) return true;

        if (!searchDigits) return false;

        return phones.some((phone) => phone.replace(/\D/g, '').includes(searchDigits));
      });
    },
  },
  methods: {
    printQuote(quoteid) {
      if (!quoteid) return;
      this.$router.push({ name: 'quote', params: { quoteid }, query: { print: 'true' } });
    },
    refreshQuotes() {
      this.refetchQuotes?.();
    },
  },
};
</script>

<style lang="scss" scoped>
.quotes-table {
  th:first-child,
  :deep(td:first-child) {
    padding-left: 3.75rem;
  }

  th,
  :deep(td) {
    max-width: 14rem;
  }

  :deep(td.status-cell) {
    overflow: visible !important;
    position: relative;

    &:has(.is-open) {
      z-index: 20;
    }
  }

  .loading-row {
    td {
      background: white;
      text-align: center;
    }

    img {
      width: 2rem;
      height: 2rem;
    }
  }
}
</style>

